module.exports = __webpack_public_path__ + "img/login_bg.5120d8f8.jpg";